import * as React from "react"

export default function AmbassadorBadgeOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3629_30932)">
        <path
          d="M6.087 1.66a2.728 2.728 0 013.93.107l.097.095c.237.21.548.32.868.305l.15-.003a2.727 2.727 0 012.704 2.705l-.003.15c-.017.365.13.718.4.965l.108.103a2.728 2.728 0 010 3.826l-.108.104c-.27.246-.417.6-.4.965l.003.149a2.727 2.727 0 01-2.705 2.705l-.15-.003c-.319-.015-.63.096-.867.305l-.097.095a2.728 2.728 0 01-3.93.108l-.103-.108a1.228 1.228 0 00-.83-.399H5.02a2.727 2.727 0 01-2.852-2.852l-.002-.137a1.227 1.227 0 00-.302-.732l-.096-.096a2.728 2.728 0 010-4.033l.096-.098c.178-.204.285-.461.302-.732l.002-.135A2.727 2.727 0 015.02 2.167l.135-.002c.316-.02.614-.162.83-.398l.103-.108zm2.82 1.117a1.228 1.228 0 00-1.72-.094l-.094.094a2.728 2.728 0 01-1.992.891l-.153-.003a1.227 1.227 0 00-1.283 1.283l.003.153a2.728 2.728 0 01-.781 1.886l-.11.106a1.227 1.227 0 000 1.814l.11.106c.495.504.775 1.18.781 1.886l-.003.153a1.228 1.228 0 001.283 1.283l.153-.003c.756.007 1.48.328 1.992.89l.095.095a1.227 1.227 0 001.72-.094l.105-.11a2.728 2.728 0 012.039-.778h.134a1.228 1.228 0 001.148-1.15l.001-.133a2.728 2.728 0 01.888-2.145l.094-.094c.41-.463.41-1.163 0-1.625l-.094-.095a2.728 2.728 0 01-.888-2.145v-.133a1.228 1.228 0 00-1.15-1.149h-.133c-.76.035-1.5-.249-2.04-.78l-.105-.109zm.563 3.36a.75.75 0 111.06 1.06L7.864 9.863a.75.75 0 01-1.06 0L5.47 8.53l-.052-.056a.75.75 0 011.056-1.056l.056.052.803.803L9.47 6.137z"
          fill={props.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3629_30932">
          <path fill="#fff" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
